import { styled, SxProps, Theme } from "@mui/material";
import { sizing } from "../utils/methods";

const Wrap = styled<any>("div")((props) =>
  props.theme.unstable_sx({
    color: props.inverted ? (props.theme.palette.mode === "dark" ? "text.secondary" : "text.primary") : "text.primary",
    fontSize: props.theme.spacing(6),
    width: "100%",
    paddingY: sizing(6),
    borderBottom: "1px solid",
    borderBottomColor: props.theme.palette.border.dark,
  })
);

type AttentionProps = {
  inverted?: boolean;
  category?: string;
  sx?: SxProps<Theme>;
  children?: Element | React.ReactNode;
};

export const Attention = (props: AttentionProps) => {
  return <Wrap {...props} />;
};

export default Attention;
